import { Fragment } from "react";
import classes from "./Footer.module.scss";
import { clsx } from "clsx";
import type { FooterProps } from "./FooterProps";
import { getAsset } from "@/utils/assets";
import { Container } from "@/components/ui/Container";
import { Heading } from "@/components/ui/Heading";
import { useFooterConfig } from "@/hooks/useFooterConfig";
import { IconResolver } from "@/components/ui/IconResolver";
import { FooterLink } from "./FooterLink";

export function Footer(props: FooterProps) {
  const { className } = props;

  const footerConfig = useFooterConfig();

  if (!footerConfig) {
    return null;
  }

  return (
    <footer className={clsx(classes.footer, className)}>
      <Container maxWidth="lg">
        <div className={classes.secureLogos}>
          <img
            src={getAsset("/images/secure-and-payment-logos.svg")}
            alt=""
            width={2157}
            height={122}
          />
        </div>

        <div className={classes.footerLayout}>
          <div className={classes.addressColumn}>
            {footerConfig.address && (
              <>
                <Heading size="md" as="h3">
                  {footerConfig.address.title}
                </Heading>
                <address className={classes.address}>
                  {footerConfig.address.lines.map((line, index) => (
                    <Fragment key={line}>
                      {index > 0 && <br />}
                      {line}
                    </Fragment>
                  ))}
                </address>
              </>
            )}
            <div className={classes.socialLinks}>
              {footerConfig.social_links.items.map((link) => (
                <a
                  key={link.url}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={link.text}
                >
                  <IconResolver
                    name={link.icon}
                    size={32}
                    color="currentColor"
                  />
                </a>
              ))}
            </div>
          </div>

          <div>
            <Heading size="md" as="h3">
              {footerConfig.contact.title}
            </Heading>
            {footerConfig.contact.items.length > 0 && (
              <ul className={classes.list}>
                {footerConfig.contact.items.map((link) => (
                  <li key={link.url}>
                    <FooterLink {...link} />
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div>
            <Heading size="md" as="h3">
              {footerConfig.other_ways.title}
            </Heading>
            {footerConfig.other_ways.items.length > 0 && (
              <ul className={classes.list}>
                {footerConfig.other_ways.items.map((link) => (
                  <li key={link.url}>
                    <FooterLink {...link} />
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div>
            <Heading size="md" as="h3">
              {footerConfig.security.title}
            </Heading>
            {footerConfig.security.items.length > 0 && (
              <ul className={classes.list}>
                {footerConfig.security.items.map((link) => (
                  <li key={link.url}>
                    <FooterLink {...link} />
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
      </Container>
    </footer>
  );
}
